//frontend/src/components/SearchManagerRequests/Chat/components/MessageInput.jsx

import React, { useRef, useState } from "react";
import EmojiPicker from "./EmojiPicker";
import AudioRecorder from "./AudioRecorder";

export default function MessageInput({
  onSendText,
  onSendFile,
  onSendAudio,
  replyTo,
  onCancelReply,
  disabled,
}) {
  const [text, setText] = useState("");
  const [emojiOpen, setEmojiOpen] = useState(false);
  const [recording, setRecording] = useState(false);
  const fileInputRef = useRef(null);

  const send = () => {
    const v = text.trim();
    if (!v) return;
    onSendText(v);
    setText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const msgtype = file.type.startsWith("image/")
      ? "m.image"
      : file.type.startsWith("video/")
      ? "m.video"
      : file.type.startsWith("audio/")
      ? "m.audio"
      : "m.file";
    onSendFile(file, msgtype);
  };

  return (
    <div className="chat-input">
      {replyTo && (
        <div className="chat-input__reply">
          <span>
            Ответ: <b>{replyTo.senderName}</b> —{" "}
            {replyTo.preview?.slice(0, 60)}
          </span>
          <button type="button" onClick={onCancelReply}>
            ×
          </button>
        </div>
      )}

      <div className="chat-input__row">
        <button
          type="button"
          className="chat-input__btn"
          title="Прикрепить файл"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled || recording}
        >
          📎
        </button>
        <input
          ref={fileInputRef}
          type="file"
          hidden
          onChange={handleFile}
        />

        {recording ? (
          <AudioRecorder
            onRecorded={(blob) => {
              setRecording(false);
              onSendAudio(blob);
            }}
            onClose={() => setRecording(false)}
          />
        ) : (
          <textarea
            className="chat-input__textarea"
            rows={1}
            placeholder="Написать сообщение…"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={disabled}
          />
        )}

        <div className="chat-input__emoji-wrap">
          <button
            type="button"
            className="chat-input__btn"
            title="Эмодзи"
            onClick={() => setEmojiOpen((v) => !v)}
            disabled={disabled || recording}
          >
            😊
          </button>
          {emojiOpen && (
            <EmojiPicker
              onPick={(emoji) => setText((t) => t + emoji)}
              onClose={() => setEmojiOpen(false)}
            />
          )}
        </div>

        <button
          type="button"
          className="chat-input__btn"
          title="Аудиосообщение"
          onClick={() => setRecording(true)}
          disabled={disabled || recording}
        >
          🎤
        </button>

        <button
          type="button"
          className="chat-input__send"
          onClick={send}
          disabled={disabled || !text.trim()}
        >
          →
        </button>
      </div>
    </div>
  );
}